export function promotionsReducer(state = {
  promotions: [],
  promotion: {},
  productList: {},
  groupList: {},
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'GET_PROMOTION_LIST_REJECTED':
    case 'GET_PROMOTION_LIST_PENDING':
    case 'GET_PROMOTION_PENDING': {
      return {...state, fetching: true, fetched: false}
    }
    case 'GET_PROMOTION_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        promotions: action.payLoad.data,
        productList: action.payLoad.meta.products,
        groupList: action.payLoad.meta.groups,
      }
    }
    case 'CLEAR_PROMOTIONS': {
      return {
        ...state,
        promotion: [],
      }
    }
    case 'GET_PROMOTION_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        promotion: action.payLoad,
        saved: false,
      }
    }
    case 'GET_PROMOTION_REJECTED': {
      return {...state, errors: action.payLoad.errors}
    }

  }
  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/promotionsReducer.js